<div class="flex-row align-center-center">
    <mat-icon class="mrs-2" [ngClass]="leftIconClass" *ngIf="leftIcon">
        {{ leftIcon }}
    </mat-icon>
    <mat-icon class="mrs-2" style="min-height: 20px; min-width: 20px;" [ngClass]="leftIconClass"
        *ngIf="leftIconSvg"
        [svgIcon]="leftIconSvg">
    </mat-icon>

    <div class="flex-row align-center-center" [formGroup]="form" class="flex-100">
        <div class="flex-100">
            <mat-checkbox
                (change)="onChange($event)"
                [formControlName]="name"
                [disabled]="disabled"
                [labelPosition]="labelPosition"
                [matTooltip]="tooltip ? tooltip : null"
                [ngClass]="{ 'checkbox-disabled': disabled }"
            >
                {{ placeholder || label }}
            </mat-checkbox>
            <mat-error
                *ngIf="
                  (form.get(name)?.errors && (form.get(name)?.dirty || form.get(name)?.touched))
                  || customError
                "
            >
                <b>
                  {{ customError ? customErrorMessage : getError() }}
                </b>
            </mat-error>

        </div>
    </div>
</div>
